import { getRuntimeConfig } from '@/utils/runtime-config';

// Helper per ottenere la config in modo sicuro
function getConfig() {
  try {
    return getRuntimeConfig();
  } catch (e) {
    // Fallback durante il caricamento iniziale
    return null;
  }
}

const API_PATHS = Object.freeze({
  BASE: 'base',
  COMMERCIO: 'commercionetwork',
  COSMOS: 'cosmos',
  COSMWASM: 'cosmwasm',
  IBC: 'ibc',
  TENDERMINT: 'tendermint',
  TX: 'tx',
});

// Create an object with getters that evaluate at runtime
const APIS = {};

// HTTP object with dynamic getters
Object.defineProperty(APIS, 'HTTP', {
  get() {
    const config = getConfig();
    const LCD = config?.chain?.lcd || '';
    const API_VERSION = config?.chain?.apiVersion || 'v1beta1';
    const API_VERSION_COSMWASM = config?.chain?.apiVersionCosmwasm || 'v1';
    const BACKEND = config?.backend?.http || '';

    return {
      LCD: LCD,
      API_VERSION: API_VERSION,
      // Backend
      BACKEND_BLOCKS: `${BACKEND}/api/v1/blocks`,
      BACKEND_CHARTS: `${BACKEND}/api/v1/charts`,
      BACKEND_TXS: `${BACKEND}/api/v1/txs`,
      BACKEND_VALIDATORS: `${BACKEND}/api/v1/validators`,
      BACKEND_WASMS: `${BACKEND}/api/v1/wasms`,
      BACKEND_HEALTHCHECK: `${BACKEND}/healthcheck`,
      // Query
      AUTH: `${LCD}/${API_PATHS.COSMOS}/auth/${API_VERSION}`,
      BANK: `${LCD}/${API_PATHS.COSMOS}/bank/${API_VERSION}`,
      DISTRIBUTION: `${LCD}/${API_PATHS.COSMOS}/distribution/${API_VERSION}`,
      SLASHING: `${LCD}/${API_PATHS.COSMOS}/slashing/${API_VERSION}`,
      STAKING: `${LCD}/${API_PATHS.COSMOS}/staking/${API_VERSION}`,
      // Service
      BLOCKS: `${LCD}/${API_PATHS.COSMOS}/${API_PATHS.BASE}/${API_PATHS.TENDERMINT}/${API_VERSION}/blocks`,
      NODE_INFO: `${LCD}/${API_PATHS.COSMOS}/${API_PATHS.BASE}/${API_PATHS.TENDERMINT}/${API_VERSION}/node_info`,
      VALIDATORSETS: `${LCD}/${API_PATHS.COSMOS}/${API_PATHS.BASE}/${API_PATHS.TENDERMINT}/${API_VERSION}/validatorsets`,
      TXS: `${LCD}/${API_PATHS.COSMOS}/${API_PATHS.TX}/${API_VERSION}`,
      // Cosmwasm
      WASM: `${LCD}/${API_PATHS.COSMWASM}/wasm/${API_VERSION_COSMWASM}`,
      // IBC
      IBC_CORE: `${LCD}/${API_PATHS.IBC}/core`,
      // Commercio
      GOVERNMENT: `${LCD}/${API_PATHS.COMMERCIO}/government`,
    };
  },
  enumerable: true,
});

// Static properties
APIS.LIMIT = 25;
APIS.SORTING_ORDERS = Object.freeze({
  ASC: 'asc',
  DESC: 'desc',
  ORDER_BY_ASC: 'ORDER_BY_ASC',
  ORDER_BY_DESC: 'ORDER_BY_DESC',
  ORDER_BY_UNSPECIFIED: 'ORDER_BY_UNSPECIFIED',
});

// WS object with dynamic getters
Object.defineProperty(APIS, 'WS', {
  get() {
    const config = getConfig();
    const WS = config?.chain?.ws || '';
    const BACKEND_WS = config?.backend?.ws || '';

    return {
      EVENTS: {
        BACKEND_ACCOUNT_STATISTICS_UPDATE: 'AccountStatisticsUpdate',
        BACKEND_NEW_HEIGHT: 'NewHeight',
        BACKEND_TOKENS_CHART_UPDATE: 'TokensChartUpdate',
        NEW_BLOCK: 'NewBlock',
        TX: 'Tx',
        TX_SET_PARAMS: 'setParams',
        VALIDATOR_SET_UPDATES: 'ValidatorSetUpdates',
      },
      URL: WS,
      URL_BACKEND: BACKEND_WS,
    };
  },
  enumerable: true,
});

export default APIS;
